module.exports = __webpack_public_path__ + "static/img/video-start.27a01bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-start.png
// module id = kSfi
// module chunks = 0